  import React, { useRef, useState, useEffect, useMemo } from 'react';
  import { toast } from "react-toastify";
  import { sendFormDataMail, isSubscriber } from "../../services/Mail_service";
  import * as XLSX from "xlsx-js-style";
  import { Tag } from "antd";
  import saveAs from "file-saver";
  import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  import {
    faFileExcel,
    faDownload,
    faTimes,
    faPlus,
    faTrash,
    faPaperclip,
    faBellSlash,
    faFile,
    faHistory,
    faEraser,
  } from "@fortawesome/free-solid-svg-icons";
  import CommitmentInfo from "../CommitmentInfo";
  import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
  import { Overlay, Popover } from "react-bootstrap";
  import FeaturesInfoBulle from "../FeaturesInfoBulle";
  import { useEmailValidation } from "../../hooks/useEmailValidation";
  import { FaCheckCircle} from 'react-icons/fa';
  import Swal from 'sweetalert2';
  import { getAcceptedLogosByUser } from "../../services/Logo_service";
  import { getAllClientByUsers } from "../../services/Login_service";
  import "react-datepicker/dist/react-datepicker.css";
  import juice from "juice";
  import SummernoteEditor from "../SummernoteEditor";
  import ImportClientsTable from "./ImportClientTable";
  import RgpdWarningModal from "./RgpdWarningModal";
  import SelectedEmailsList from "./SelectedEmailsList";

  interface Logo {
    id: number;
    libelle: string;
    user_id?: number;
    floId?: string;
    logo_status: string;
  }

  interface RecipientDetails {
    name?: string;
    adresse?: string;
    codePostal?: string;
    ville?: string;
    telephone?: string;
    profession?: string;
    dirigeant?: string;
    siret?: string;
    commentaires?: string;
  }

  interface EmailOption {
    value: string;
    label: string;
    details?: RecipientDetails;
  }

  interface MailTabProps {
    authUser: any;
  }

  const MailTab: React.FC<MailTabProps> = ({ authUser }) => {
    const [mounted, setMounted] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [emailData, setEmailData] = useState({
      name: "",
      object: "",
      sender: "",
      bcc: [],
    });
    const [selectedEmailOptions, setSelectedEmailOptions] = useState<EmailOption[]>([]);
    const [editorHtml, setEditorHtml] = useState<string>("");
    const [attachments, setAttachments] = useState<{
      attachments: File[];
      coverImage?: {
        file: File;
        preview: string;
      };
    }>({
      attachments: [],
      coverImage: undefined,
    });

    const htmlWithInlineStyles = juice(editorHtml);
    const [fileName, setFileName] = useState<string | undefined>(undefined);
    const [showTooltip, setShowTooltip] = useState({ features: false });
    const [target, setTarget] = useState(null);
    const [inputEmail, setInputEmail] = useState<string>();
    const [selectedLogoId, setSelectedLogoId] = useState<number | null>(null);
    const [acceptedLogos, setAcceptedLogos] = useState<Logo[]>([]);
    const [filteredClient, setFilteredClient] = useState<any[]>([]);
    const [showEmailTable, setShowEmailTable] = useState<boolean>(false);
    const [showInputField, setShowInputField] = useState<boolean>(true);
    const [importType, setImportType] = useState<string | null>(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedEmails, setSelectedEmails] = useState<Set<string>>(new Set());
    const [agreementOpen, setAgreementOpen] = useState<boolean>(false);
    const [isChecked, setIsChecked] = useState(false);
    const [allowUnsubscribe, setAllowUnsubscribe] = useState(true);
    const [showRgpdWarning, setShowRgpdWarning] = useState(false);

    const { isValidEmail } = useEmailValidation();

    const emailInputRef = useRef<HTMLInputElement | null>(null);
    const attachmentInputRef = useRef<HTMLInputElement | null>(null);
    const coverImageInputRef = useRef<HTMLInputElement | null>(null);
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const sendMailRef = useRef<HTMLButtonElement | null>(null);
    const htmlInputRef = useRef<HTMLInputElement | null>(null);

    const [headerColor, setHeaderColor] = useState<string>("#2A919D");

    const [lastUsedColor, setLastUsedColor] = useState<string>("#2A919D");


    const handleRemoveAllRecipients = () => {
      if (selectedEmailOptions.length === 0) {
        toast.warning("Aucun destinataire à supprimer");
        return;
      }
    
      if (window.confirm(`Êtes-vous sûr de vouloir supprimer tous les ${selectedEmailOptions.length} destinataire(s) ?`)) {
        setSelectedEmailOptions([]);
        setSelectedEmails(new Set()); 
        toast.success("Tous les destinataires ont été supprimés");
      }
    };


    useEffect(() => {
    const savedColor = localStorage.getItem("lastHeaderColor");
    if (savedColor) {
      setHeaderColor(savedColor);
      setLastUsedColor(savedColor);
    }
  }, []);

    const handleColorChange = (newColor: string) => {
      setHeaderColor(newColor);
      setLastUsedColor(newColor);
      localStorage.setItem("lastHeaderColor", newColor);
    };

    const [importedHtml, setImportedHtml] = useState<{
    file?: File;
    content?: string;
    name?: string;
  }>({});

    const ref = useRef(null);

    useEffect(() => {
      if (showRgpdWarning) {
        setAllowUnsubscribe(true);
      }
    }, [showRgpdWarning]);

    useEffect(() => {
      if (!mounted) {
        isSubscriber().then((response: any) => {
          setAllowUnsubscribe(response.subscribed === true);
          setMounted(true);
        }).catch((error) => {
          console.error("Erreur lors de la vérification de l'abonnement:", error);
          setAllowUnsubscribe(false);
          setMounted(true);
        });
      }
    }, [mounted]);

    useEffect(() => {
      const importedRecipients = localStorage.getItem("importedRecipients");
      if (importedRecipients) {
        try {
          const recipientsArray = JSON.parse(importedRecipients);
          const newOptions = recipientsArray.map((email: string) => ({
            label: email,
            value: email,
          }));
          setSelectedEmailOptions((prev) => {
            const existingEmails = prev.map(opt => opt.value);
            const uniqueNew = newOptions.filter(
              (opt: { value: string; label: string }) => !existingEmails.includes(opt.value)
            );
            return [...prev, ...uniqueNew];
          });
          localStorage.removeItem("importedRecipients");
          toast.info(`${recipientsArray.length} destinataire(s) importé(s)`, {
            position: "top-right",
            autoClose: 3000,
          });
        } catch (error) {
          console.error("Erreur lors de l'import des destinataires:", error);
          toast.error("Erreur lors de l'import des destinataires");
        }
      }
    }, []);

    useEffect(() => {
      const loadAcceptedLogos = async () => {
        const logos = await getAcceptedLogosByUser();
        setAcceptedLogos(logos);
      };
      loadAcceptedLogos();
    }, []);

    useEffect(() => {
      if (selectedEmails) {
        const emailsSelected = Array.from(selectedEmails);
        const missingEmails = emailsSelected.filter(
          (email) => !selectedEmailOptions.some((option) => option.label === email)
        );
        const newOptions = missingEmails.map((email) => ({
          label: email,
          value: email,
        }));
        setSelectedEmailOptions((prev: { value: string; label: string }[]) => [
          ...prev,
          ...newOptions,
        ]);
      }
    }, [selectedEmails, selectedEmailOptions]);

    const filteredAndSortedClients = useMemo(() => {
      return filteredClient.filter((client) => {
        const search = searchTerm.toLowerCase();
        const fullName = `${client.name} ${client.firstname}`.toLowerCase();
        const email = client.email.toLowerCase();
        const matchesSearch = fullName.includes(search) || email.includes(search);

        const clientDate = new Date(client.createdAt);
        const matchesDate =
          (!startDate || clientDate >= startDate) &&
          (!endDate || clientDate <= endDate);

        return matchesSearch && matchesDate;
      });
    }, [filteredClient, searchTerm, startDate, endDate]);


    const handleHtmlImport = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target?.result) {
          const content = event.target.result as string;
          setEditorHtml(content);
          setImportedHtml({
            file: file,
            content: content,
            name: file.name
          });
          toast.success("Contenu HTML importé avec succès");
        }
      };
      reader.readAsText(file, "UTF-8");
    }
  };
    const handleRemoveHtml = () => {
      setEditorHtml("");
      setImportedHtml({});
      if (htmlInputRef.current) {
        htmlInputRef.current.value = "";
      }
      toast.info("Fichier HTML supprimé");
    };

    const getListUsers = async () => {
      setLoading(true);
      const userId = localStorage.getItem("userId");

      if (userId) {
        try {
          const clients = await getAllClientByUsers(parseInt(userId));
          const filteredClients = clients.filter(
            (client) => client.status !== "anonymous"
          );
          setFilteredClient(filteredClients);
          setShowEmailTable(true);
          setShowInputField(false);
          setImportType("clients");
        } catch (error) {
          console.error("Erreur lors de la récupération des clients", error);
          toast.error("Erreur lors de la récupération des clients.");
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    const sortBy = (key: "name" | "firstname" | "email" | "createdAt") => {
      const sorted = [...filteredClient].sort((a, b) => {
        if (key === "createdAt") {
          return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
        }
        return a[key].localeCompare(b[key]);
      });
      setFilteredClient(sorted);
    };

    const handleClientCheckboxChange = (email: string) => {
      setSelectedEmails((prevSelected) => {
        const newSelected = new Set(prevSelected);
        if (newSelected.has(email)) {
          newSelected.delete(email);
        } else {
          newSelected.add(email);
        }
        return newSelected;
      });
    };

    const handleIsCheck = (isCheck: boolean) => {
      setIsChecked(isCheck);
    };

    const handleAgreementOpen = (value: boolean) => {
      setAgreementOpen(value);
    };
  const checkQuotaBeforeSend = async (userEmail:any, emailsToSend:any) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/quota/check?sender=${encodeURIComponent(userEmail)}`);
      
      if (!response.ok) {
        throw new Error("Erreur API");
      }
      
      const quotaData = await response.json();
      
      const quotaInfo = {
        daily: { 
          used: quotaData.dailyUsed || 0, 
          limit: quotaData.dailyQuota || 0 
        },
        monthly: { 
          used: quotaData.monthlyUsed || 0, 
          limit: quotaData.monthlyQuota || 0 
        },
        yearly: { 
          used: quotaData.yearlyUsed || 0, 
          limit: quotaData.yearlyQuota || 0 
        },
        nextReset: quotaData.nextReset || {
          daily: new Date(Date.now() + 24*60*60*1000).toLocaleDateString('fr-FR'),
          monthly: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toLocaleDateString('fr-FR'),
          yearly: new Date(new Date().getFullYear() + 1, 0, 1).toLocaleDateString('fr-FR')
        }
      };
      
      // Calculer ce qui va dépasser
      const willExceedDaily = quotaInfo.daily.limit > 0 && (quotaInfo.daily.used + emailsToSend) > quotaInfo.daily.limit;
      const willExceedMonthly = quotaInfo.monthly.limit > 0 && (quotaInfo.monthly.used + emailsToSend) > quotaInfo.monthly.limit;
      const willExceedYearly = quotaInfo.yearly.limit > 0 && (quotaInfo.yearly.used + emailsToSend) > quotaInfo.yearly.limit;
      
      const willExceed = willExceedDaily || willExceedMonthly || willExceedYearly;
      
      // Calculer combien seront rejetés
      let willBeRejected = 0;
      let limitingQuota = null;
      
      if (willExceedDaily) {
        const availableDaily = quotaInfo.daily.limit - quotaInfo.daily.used;
        willBeRejected = emailsToSend - availableDaily;
        limitingQuota = "journalier";
      } else if (willExceedMonthly) {
        const availableMonthly = quotaInfo.monthly.limit - quotaInfo.monthly.used;
        willBeRejected = emailsToSend - availableMonthly;
        limitingQuota = "mensuel";
      } else if (willExceedYearly) {
        const availableYearly = quotaInfo.yearly.limit - quotaInfo.yearly.used;
        willBeRejected = emailsToSend - availableYearly;
        limitingQuota = "annuel";
      }
      
      return {
        ...quotaInfo,
        willExceed,
        willBeRejected: Math.max(0, willBeRejected),
        emailsToSend,
        limitingQuota
      };
      
    } catch (error) {
      console.error("❌ Erreur vérification quota:", error);
      return null;
    }
  };
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Validations de base (inchangées)
    if (!emailData.object.trim()) {
      toast.error("L'objet est requis.");
      return;
    }

    if (!selectedEmailOptions || selectedEmailOptions.length === 0) {
      toast.error("Veuillez ajouter au moins un destinataire.");
      return;
    }

    if (!isChecked) {
      handleAgreementOpen(true);
      return;
    }

    // 🔴 NOUVEAU : Vérification des quotas avant envoi
    setLoading(true);
    
    try {
    const quotaInfo = await checkQuotaBeforeSend(authUser?.email, selectedEmailOptions.length);

  // 🔴 CORRECTION : Vérifier si quotaInfo n'est pas null
  if (quotaInfo && quotaInfo.willExceed) {
    const result = await Swal.fire({
      icon: "warning",
      title: "⚠️ Attention : quota d'envoi limité",
      html: `
        <div style="text-align: left; font-family: Arial, sans-serif;">
          <p style="margin-bottom: 15px; font-size: 1.1em;">
            Vous tentez d'envoyer <strong style="color: #2A919D;">${quotaInfo.emailsToSend} email(s)</strong>
          </p>
          
          <div style="background: #f8f9fa; padding: 15px; border-radius: 8px; margin: 15px 0; border-left: 4px solid #dc3545;">
            <p style="margin: 0 0 10px 0; font-weight: bold;">📊 Votre consommation actuelle :</p>
            <p style="margin: 5px 0;">📅 Journalier : ${quotaInfo.daily.used}/${quotaInfo.daily.limit}</p>
            <p style="margin: 5px 0;">📆 Mensuel : ${quotaInfo.monthly.used}/${quotaInfo.monthly.limit}</p>
            <p style="margin: 5px 0;">🗓️ Annuel : ${quotaInfo.yearly.used}/${quotaInfo.yearly.limit}</p>
          </div>
          
          <div style="background: #fff3cd; padding: 15px; border-radius: 8px; margin: 15px 0; border-left: 4px solid #ffc107;">
            <p style="margin: 0 0 10px 0; font-weight: bold; color: #856404;">⚠️ Conséquence :</p>
            <p style="margin: 5px 0; color: #856404;">
              <strong style="font-size: 1.2em;">${quotaInfo.willBeRejected} email(s)</strong> seront rejetés
            </p>
            <p style="margin: 5px 0; color: #856404;">
              Seuls ${quotaInfo.emailsToSend - quotaInfo.willBeRejected} pourront être envoyés
            </p>
          </div>
          
          <div style="background: #e7f3ff; padding: 15px; border-radius: 8px; margin: 15px 0;">
            <p style="margin: 0 0 10px 0; font-weight: bold;">💡 Solutions :</p>
            <ul style="margin: 0; padding-left: 20px;">
              <li>Réduire à <strong>${quotaInfo.daily.limit - quotaInfo.daily.used}</strong> destinataire(s) maintenant</li>
              <li>Attendre la réinitialisation :
                <br/>📅 Journalier : ${quotaInfo.nextReset.daily}
                <br/>📆 Mensuel : ${quotaInfo.nextReset.monthly}
              </li>
              <li>
                <a href="/gestion-emails" style="color: #2A919D; font-weight: bold; text-decoration: underline;">
                  ➡️ Aller dans l'onglet "Mes offres et quotas" pour augmenter vos limites
                </a>
              </li>
            </ul>
          </div>
          
          <p style="text-align: center; margin-top: 20px; font-weight: bold;">
            Que souhaitez-vous faire ?
          </p>
        </div>
      `,
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: "Envoyer quand même",
      cancelButtonText: " Modifier ma sélection",
      denyButtonText: " Voir les offres",
      confirmButtonColor: "#2A919D",
      cancelButtonColor: "#6c757d",
      denyButtonColor: "#f4a261",
      reverseButtons: true,
      width: '600px'
    });

    if (result.isDenied) {
      window.location.href = "/gestion-emails?tab=EnvoyerMail";
      return;
    }

    if (result.isDismissed) {
      setLoading(false);
      return;
    }
    
  } 
  else if (!quotaInfo) {  
    console.warn("⚠️ Impossible de vérifier les quotas, envoi quand même");
    // Optionnel : toast ou petite alerte
    toast.warning("Vérification des quotas indisponible, envoi quand même...");
  }
      // ✅ SUITE DU CODE D'ENVOI (votre boucle existante)
      let successCount = 0;
      let errorCount = 0;
      const errors: string[] = [];

      for (let i = 0; i < selectedEmailOptions.length; i++) {
        const recipient = selectedEmailOptions[i];

        try {
          const { value: email, details } = recipient;
          const safeDetails: RecipientDetails = details || {};

          const formData = new FormData();
          formData.append("object", emailData.object);
          formData.append("sender", authUser?.email as string);
          formData.append("bcc", JSON.stringify([email]));
          formData.append("isClient", "true");
          formData.append("userId", `${authUser?.id}`);
          formData.append("allowUnsubscribe", allowUnsubscribe ? "true" : "false");
          formData.append("details", JSON.stringify(safeDetails));
          formData.append("message", htmlWithInlineStyles);
          formData.append("headerColor", headerColor);

          if (selectedLogoId !== null) {
            formData.append("selectedLogoId", selectedLogoId.toString());
          }

          attachments.attachments.forEach((file) =>
            formData.append("attachments", file)
          );

          if (attachments.coverImage) {
            formData.append("coverImage", attachments.coverImage.file);
          }

          await sendFormDataMail(formData);
          successCount++;
          
        } catch (emailError: any) {
          errorCount++;
          // Analyser le type d'erreur pour un message clair
          let errorMsg = emailError.message || "Erreur inconnue";
          
          if (errorMsg.includes("Quota") || errorMsg.includes("quota")) {
            errorMsg = "Quota atteint - email non envoyé";
          } else if (errorMsg.includes("login") || errorMsg.includes("SMTP")) {
            errorMsg = "Erreur de connexion au serveur";
          }
          
          errors.push(`${recipient.value}: ${errorMsg}`);
        }
      }

      // Messages de résultat (votre code existant)
      if (successCount > 0 && errorCount === 0) {
        toast.success(`✓ ${successCount} email(s) envoyé(s) avec succès !`, {
          autoClose: 3000
        });
        
        // Reset du formulaire
        setEmailData({ bcc: [], name: "", object: "", sender: "" });
        setImportedHtml({});
        setEditorHtml("");
        setAttachments({ attachments: [], coverImage: undefined });
        setSelectedEmailOptions([]);
        setInputEmail(undefined);
        setShowEmailTable(false);
        setFilteredClient([]);
        setImportType(null);
        setSelectedEmails(new Set());

      } else if (successCount > 0 && errorCount > 0) {
        // Message d'envoi partiel avec détails
        await Swal.fire({
          icon: "warning",
          title: "📧 Envoi partiel",
          html: `
            <div style="text-align: left;">
              <p style="color: #28a745;">✓ ${successCount} email(s) envoyé(s)</p>
              <p style="color: #dc3545;">✗ ${errorCount} échec(s)</p>
              <hr/>
              <p><strong>Détails des échecs :</strong></p>
              <ul style="max-height: 200px; overflow-y: auto;">
                ${errors.map(err => `<li style="color: #dc3545;">${err}</li>`).join("")}
              </ul>
            </div>
          `,
          confirmButtonText: "OK",
          confirmButtonColor: "#2A919D"
        });

      } else if (errorCount > 0) {
        // Message d'échec total
        await Swal.fire({
          icon: "error",
          title: "❌ Échec de l'envoi",
          html: `
            <div style="text-align: left;">
              <p>Aucun email n'a pu être envoyé.</p>
              <hr/>
              <p><strong>Erreurs :</strong></p>
              <ul style="max-height: 200px; overflow-y: auto;">
                ${errors.map(err => `<li>${err}</li>`).join("")}
              </ul>
            </div>
          `,
          confirmButtonText: "Réessayer",
          confirmButtonColor: "#2A919D"
        });
      }

    } catch (error: any) {
      console.error("❌ Erreur globale:", error);
      
      await Swal.fire({
        icon: "error",
        title: "Erreur système",
        text: "Une erreur inattendue s'est produite. Veuillez réessayer plus tard.",
        confirmButtonText: "OK",
        confirmButtonColor: "#EF214F"
      });

    } finally {
      setLoading(false);
    }
  };

    const handleDownloadExample = () => {
      const exampleData = [
        [
          "Email",
          "Nom & Prénom(s) (Facultatif)",
          "Adresse (Facultatif)",
          "Code Postal (Facultatif)",
          "Ville (Facultatif)",
          "Téléphone (Facultatif)",
          "Profession (Facultatif)",
          "Dirigeant (Facultatif)",
          "SIRET (Facultatif)",
          "Commentaires (Facultatif)"
        ],
        [
          "exemple1@mail.com",
          "Dupont Jean",
          "12 Rue de Paris",
          "75001",
          "Paris",
          "0123456789",
          "Avocat",
          "Jean Dupont",
          "12345678900012",
          "Ici votre commentaire"
        ],
        [
          "exemple2@mail.com",
          "Martin Claire",
          "34 Avenue Victor Hugo",
          "69003",
          "Lyon",
          "0987654321",
          " Entrepreneur",
          "Claire Martin",
          "98765432100034",
          "Ici votre commentaire"
        ],
        [
          "exemple3@mail.com",
          "Durand Paul",
          "56 Boulevard Saint-Germain",
          "75005",
          "Paris",
          "0147852369",
          "Médecin",
          "Paul Durand",
          "45678912300056",
          "Ici votre commentaire"
        ],
      ];

      const worksheet = XLSX.utils.aoa_to_sheet(exampleData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Clients");

      const worksheetRef = worksheet["!ref"];
      if (worksheetRef) {
        const headerRange = XLSX.utils.decode_range(worksheetRef);
        for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
          if (worksheet[cellAddress]) {
            worksheet[cellAddress].s = {
              fill: { patternType: "solid", fgColor: { rgb: "4BB0C0" } },
              font: { bold: true, color: { rgb: "FFFFFF" } },
              alignment: { horizontal: "center", vertical: "center" },
            };
          }
        }
      }

      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(blob, "clients_modele.xlsx");
    };

    const handleClickValid = () => {
      const emailValue = emailInputRef.current?.value;
      if (
        emailValue &&
        !selectedEmailOptions?.map((email) => email.value).includes(emailValue)
      ) {
        setSelectedEmailOptions((prev) => [
          ...prev,
          { label: emailValue.trim(), value: emailValue.trim() },
        ]);
        if (emailInputRef.current) {
          emailInputRef.current.value = "";
        }
        setInputEmail(undefined);
      }
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      if (!file) return;

      setFileName(file.name);

      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        if (!e.target?.result) return;

        try {
          const data = new Uint8Array(e.target.result as ArrayBuffer);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];

          const json: any[] = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

          if (!json[0]?.Email) {
            toast.error("Le fichier doit contenir au moins l'en-tête : Email.");
            return;
          }

          const newEmailOptions: EmailOption[] = json.map((row: any) => ({
            label: row.Email,
            value: row.Email,
            details: {
              name: row["Nom & Prénom(s) (Facultatif)"] || "",
              adresse: row["Adresse (Facultatif)"] || "",
              codePostal: row["Code Postal (Facultatif)"] || "",
              ville: row["Ville (Facultatif)"] || "",
              telephone: row["Téléphone (Facultatif)"] || "",
              profession: row["Profession (Facultatif)"] || "",
              dirigeant: row["Dirigeant (Facultatif)"] || "",
              siret: row["SIRET (Facultatif)"] || "",
              commentaires: row["Commentaires (Facultatif)"] || "",
            },
          }));

          setSelectedEmailOptions((prev) => [...prev, ...newEmailOptions]);
          toast.success(`${json.length} destinataire(s) importé(s) avec succès.`);
        } catch (error) {
          console.error("Erreur lors de la lecture du fichier:", error);
          toast.error("Erreur lors de la lecture du fichier Excel.");
        }
      };

      reader.readAsArrayBuffer(file);
    };

    const handleInputChange = (
      e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
      const { id, value } = e.target;
      setEmailData((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    };

    const handleInputKeyDownEmail = (
      event: React.KeyboardEvent<HTMLInputElement>
    ) => {
      const inputValue = (event.target as HTMLInputElement).value.trim();
      setInputEmail(inputValue);
      if ((event.key === " " || event.key === "Enter") && inputValue) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(inputValue)) {
          console.error("Invalid email format");
          return;
        }

        if (
          !selectedEmailOptions?.map((email) => email.value).includes(inputValue)
        ) {
          setSelectedEmailOptions((prev) => [
            ...prev,
            { label: inputValue.trim(), value: inputValue.trim() },
          ]);
        }

        (event.target as HTMLInputElement).value = "";
        if (emailInputRef.current) {
          emailInputRef.current.value = "";
        }
        setInputEmail(undefined);
      }
    };

    const handleCoverImageChange = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      const files = event.target.files;
      if (files && files[0] && files[0].type.startsWith("image/")) {
        const file = files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          if (e.target) {
            setAttachments((prev) => ({
              ...prev,
              coverImage: {
                file: file,
                preview: e.target?.result as string,
              },
            }));
          }
        };
        reader.readAsDataURL(file);
      }
    };

    const handleRemoveCoverImage = () => {
      setAttachments((prev) => ({ ...prev, coverImage: undefined }));
    };

    const handleAttachmentChange = (
      event: React.ChangeEvent<HTMLInputElement>
    ) => {
      const files = event.target.files;
      if (files) {
        setAttachments((prev) => ({
          ...prev,
          attachments: [...prev.attachments, ...Array.from(files)],
        }));
      }
    };

    const handleRemoveAttachment = (index: number) => {
      setAttachments((prev) => ({
        ...prev,
        attachments: prev.attachments.filter((_, i) => i !== index),
      }));
    };

    const handleClickInfoFeatures = (event: any) => {
      setTarget(event.target);
      setShowTooltip((prev) => ({ ...prev, features: !prev.features }));
    };

    return (
      <>
        {agreementOpen && (
          <CommitmentInfo
            isChecked={isChecked}
            handleIsCheck={handleIsCheck}
            handleCancel={() => handleAgreementOpen(false)}
            handleContinue={async () => {
              handleAgreementOpen(false);
              sendMailRef.current?.click();
            }}
          />
        )}

        {showInputField && importType === "file" && (
          <div className="mb-3">
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                id="destinataire"
                placeholder="Destinataire"
                value={fileName}
                readOnly
              />
            </div>
          </div>
        )}

      {!agreementOpen && showEmailTable && (
        <ImportClientsTable
          clients={filteredAndSortedClients}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          isDropdownOpen={isDropdownOpen}
          setIsDropdownOpen={setIsDropdownOpen}
          sortBy={sortBy}
          selectedEmails={selectedEmails}
          onToggleEmail={handleClientCheckboxChange}
        />
      )}


        <form
          className={`mt-3 ${agreementOpen ? "d-none" : ""}`}
          onSubmit={handleSubmit}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
            }
          }}
        >
          <div className="mb-3 d-flex align-items-center flex-wrap gap-2">
            <div className="me-2" ref={ref}>
              <div className="d-flex">
                <FontAwesomeIcon
                  size="xl"
                  icon={faInfoCircle}
                  className="ms-auto cursor-pointer color-orange fs-36"
                  onBlur={() => {
                    setShowTooltip((prev) => ({ ...prev, features: false }));
                  }}
                  onClick={handleClickInfoFeatures}
                  aria-label="Information sur la clause"
                />
                <Overlay
                  show={showTooltip.features}
                  target={target}
                  placement="right"
                  container={ref.current}
                  containerPadding={20}
                >
                  <Popover
                    id="popover-contained"
                    style={{
                      maxWidth: "380px",
                      maxHeight: "500px",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <FeaturesInfoBulle
                      handleClose={() =>
                        setShowTooltip((prev) => ({ ...prev, features: false }))
                      }
                    />
                  </Popover>
                </Overlay>
              </div>
            </div>

            <div className="action-buttons-container">
              {authUser?.user_type !== 'personne' && (
                <Tag 
                  className="py-2 cursor-pointer" 
                  onClick={getListUsers} 
                  style={{ backgroundColor: "#2A919D", color: "white", border: "none" }}
                >
                  <FontAwesomeIcon icon={faFile} style={{ marginRight: "10px" }} /> 
                  Importer les emails des Clients
                </Tag>
              )}
              
              <Tag
                className="py-2 cursor-pointer"
                onClick={() => fileInputRef.current?.click()}
                style={{ backgroundColor: "#2A919D", color: "white", border: "none" }}
              >
                <FontAwesomeIcon icon={faFileExcel} style={{ marginRight: "10px" }} /> 
                Importer un fichier Excel
              </Tag>

              <Tag
                className="py-2 cursor-pointer"
                onClick={handleDownloadExample}
                style={{ backgroundColor: "#2A919D", color: "white", border: "none" }}
              >
                <FontAwesomeIcon icon={faDownload} style={{ marginRight: "10px" }} /> 
                Télécharger le modèle d'import Excel
              </Tag>

              <input
                type="file"
                ref={fileInputRef}
                accept=".xlsx, .xls"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </div>
          </div>

          <div className="row form-row">
            <div className="col-md-12">
              <div className="mb-3">
                <label htmlFor="object">Objet</label>
                <input
                  type="text"
                  className="form-control"
                  id="object"
                  value={emailData.object}
                  onChange={handleInputChange}
                  aria-label="Objet de l'email"
                />
              </div>
              <div className="mb-3">
                <div className="d-flex flex-column gap-2">
                  <div className="w-100">
                    <label htmlFor="email">Saisir email destinataire</label>
                    <input
                      ref={emailInputRef}
                      className="form-control"
                      type="text"
                      onKeyDown={handleInputKeyDownEmail}
                      onBlur={() => {
                        if (!emailInputRef.current) return;
                        const emailValue = emailInputRef.current.value.trim();
                        if (emailValue && isValidEmail(emailValue)) {
                          setSelectedEmailOptions(prev => [
                            ...prev,
                            { value: emailValue, label: emailValue }
                          ]);
                          emailInputRef.current.value = "";
                        }
                      }}
                      aria-label="Email du destinataire"
                    />
                  </div>
                  <div>
                    <Tag
                      className="py-2 cursor-pointer bg-societe"
                      onClick={handleClickValid}
                    >
                      <FontAwesomeIcon icon={faPlus} style={{ marginRight: "10px" }} /> 
                      Ajouter cet email comme destinataire
                    </Tag>
                  </div>
                </div>
              </div>
              {selectedEmailOptions?.length > 0 && (
                <>
              <div className="d-flex justify-content-between align-items-center">
                <label htmlFor="objet">Email(s) ajoutés ({selectedEmailOptions.length})</label>
                {selectedEmailOptions.length > 0 && (
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={handleRemoveAllRecipients}
                    title="Supprimer tous les destinataires"
                    style ={{marginRight:"10px",marginBottom:"10px"}}
                  >
                    <FontAwesomeIcon icon={faEraser} className="me-1" />
                    Tout supprimer
                  </button>
                )}
              </div>
            <SelectedEmailsList
                emails={selectedEmailOptions}
                onRemove={(index) =>
                  setSelectedEmailOptions((prev) =>
                    prev.filter((_, i) => i !== index)
                  )
                }
              />

                </>
              )}
            </div>
            <div className="rich">
              <SummernoteEditor
                value={editorHtml}
                onChange={(content) => setEditorHtml(content)}
              />
            </div>
            <div className="row form-row">
              <div className="col-md-6" style={{ marginTop: "150px" }}>
                <div className="d-flex flex-column me-4">
                  <div className="mb-3">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleCoverImageChange}
                      style={{ display: "none" }}
                      ref={coverImageInputRef}
                    />
                  <input
                    type="file"
                    accept=".html,.htm"
                    style={{ display: "none" }}
                    ref={htmlInputRef}
                    onChange={handleHtmlImport}
                  />

                    <select
                      className="form-select w-auto"
                      defaultValue=""
                      onChange={(e) => {
                        if (e.target.value === "coverImage") {
                          coverImageInputRef.current?.click();
                        } else if (e.target.value === "html") {
                          htmlInputRef.current?.click();
                        }
                        e.target.value = "";
                      }}
                      aria-label="Choisir une action"
                    >
                      <option value="" disabled>
                        Choisir une action
                      </option>
                      <option value="coverImage">Image de couverture - Newsletter (JPEG, PNG)</option>
                      <option value="html">Ajouter un Newsletter HTML</option>
                    </select>
                  </div>

                  {/* Affichage du fichier HTML importé */}
                  {importedHtml.name && (
                    <div className="mb-3">
                      <div className="d-flex align-items-center p-2 border rounded bg-light">
                        <FontAwesomeIcon icon={faFile} className="me-2 text-primary" />
                        <span className="flex-grow-1">{importedHtml.name}</span>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger ms-2"
                          onClick={handleRemoveHtml}
                          title="Supprimer le fichier HTML"
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                        <span className="text-success ms-2">
                          <FaCheckCircle />
                        </span>
                      </div>
                    </div>
                  )}
                  {/* Sélecteur de couleur pour l'en-tête */}
                  <div className="mb-4">
                    <div className="d-flex align-items-center mb-2">
                      <label className="form-label me-2 mb-0">Couleur de l'en-tête</label>
                      <FontAwesomeIcon 
                        icon={faInfoCircle} 
                        title="Choisissez la couleur de fond de l'en-tête de l'email" 
                        style={{ color: '#2A919D', cursor: 'pointer' }} 
                      />
                    </div>
                    <div className="d-flex align-items-center gap-3 flex-wrap">
                      <input
                        type="color"
                        className="form-control form-control-color"
                        value={headerColor}
                        onChange={(e) => handleColorChange(e.target.value)}
                        style={{ width: '60px', height: '38px', padding: '4px' }}
                        title="Choisir une couleur"
                      />
                      <input
                        type="text"
                        className="form-control"
                        value={headerColor}
                        onChange={(e) => handleColorChange(e.target.value)}
                        placeholder="#2A919D"
                        style={{ width: '120px' }}
                        pattern="^#[0-9A-Fa-f]{6}$"
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => handleColorChange("#2A919D")}
                        style={{ fontSize: '0.9rem' }}
                      >
                        Réinitialiser
                      </button>
                      {lastUsedColor && lastUsedColor !== "#2A919D" && (
                        <button
                          type="button"
                          className="btn btn-outline-info"
                          onClick={() => handleColorChange(lastUsedColor)}
                          style={{ fontSize: '0.9rem' }}
                        >
                          <FontAwesomeIcon icon={faHistory} className="me-1" />
                          Dernière couleur utilisée
                        </button>
                      )}
                    </div>
                  </div>



                  <div className="attachment-cover-image ms-4">
                    {attachments.coverImage && (
                      <div className="attachment-item d-flex align-items-center">
                        <span className="attachment-name">
                          <img
                            src={attachments.coverImage.preview}
                            alt="Cover Preview"
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                              marginRight: "10px",
                            }}
                          />
                        </span>
                        <span
                          className="cursor-pointer text-danger ms-2"
                          onClick={() => handleRemoveCoverImage()}
                          aria-label="Supprimer l'image de couverture"
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex flex-column mb-2">
                  <div className="mb-3">
                    <input
                      type="file"
                      accept="*"
                      multiple
                      onChange={handleAttachmentChange}
                      style={{ display: "none" }}
                      ref={attachmentInputRef}
                    />
                    <div>
                      <Tag
                        className="py-2 cursor-pointer"
                        onClick={() => attachmentInputRef.current?.click()}
                      >
                        <FontAwesomeIcon icon={faPaperclip} /> Pièces jointes
                      </Tag>
                    </div>
                  </div>
                  <div className="attachments-list">
                    {attachments?.attachments?.map((file, index) => (
                      <div
                        key={index}
                        className="attachment-item d-flex align-items-center"
                      >
                        <span className="attachment-name">{file.name}</span>
                        <span
                          className="cursor-pointer text-danger ms-2"
                          onClick={() => handleRemoveAttachment(index)}
                          aria-label={`Supprimer ${file.name}`}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="mb-4">
              <div className="d-flex align-items-center mb-2">
                <label className="form-label me-2 mb-0">Logo à afficher dans l'email</label>
                <FontAwesomeIcon 
                  icon={faInfoCircle} 
                  title="Seuls les logos acceptés sont proposés. Cliquez sur un logo pour le sélectionner. Survolez pour agrandir." 
                  style={{ color: '#2A919D', cursor: 'pointer' }} 
                />
              </div>
              <div className="row g-3">
                <div className="col-auto">
                  <label 
                    className="d-flex flex-column align-items-center logo-radio-card p-2 shadow-sm rounded-3 bg-light position-relative" 
                    style={{ 
                      minWidth: 110, 
                      minHeight: 140, 
                      border: selectedLogoId === null ? '2px solid #2A919D' : '1px solid #ccc', 
                      cursor: 'pointer', 
                      transition: 'border 0.2s' 
                    }}
                  >
                    <input
                      type="radio"
                      name="selectedLogo"
                      checked={selectedLogoId === null}
                      onChange={() => setSelectedLogoId(null)}
                      style={{ marginBottom: '5px' }}
                      aria-label="Logo par défaut"
                    />
                    <div style={{ 
                      width: '80px', 
                      height: '80px', 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center', 
                      background: '#f8f9fa', 
                      borderRadius: 12 
                    }}>
                      <FontAwesomeIcon icon={faTimes} size="2x" style={{ color: '#bbb' }} />
                    </div>
                    <span style={{ fontSize: '0.9em', marginTop: 8, color: '#555' }}>Logo par défaut</span>
                  </label>
                </div>
                {acceptedLogos.length > 0 ? (
                  acceptedLogos.map((logo) => (
                    <div key={logo.id} className="col-auto">
                      <label 
                        className="d-flex flex-column align-items-center logo-radio-card p-2 shadow-sm rounded-3 bg-white position-relative" 
                        style={{ 
                          minWidth: 110, 
                          minHeight: 140, 
                          border: selectedLogoId === logo.id ? '2px solid #2A919D' : '1px solid #ccc', 
                          cursor: 'pointer', 
                          transition: 'border 0.2s' 
                        }}
                      >
                        <input
                          type="radio"
                          name="selectedLogo"
                          checked={selectedLogoId === logo.id}
                          onChange={() => setSelectedLogoId(logo.id)}
                          style={{ marginBottom: '5px' }}
                          aria-label={`Sélectionner le logo ${logo.libelle.split('/').pop()}`}
                        />
                        <div
                          style={{ 
                            width: '80px', 
                            height: '80px', 
                            borderRadius: 12, 
                            overflow: 'hidden', 
                            background: '#f8f9fa', 
                            boxShadow: selectedLogoId === logo.id ? '0 0 0 3px #2A919D33' : '0 1px 4px #0001', 
                            position: 'relative' 
                          }}
                          className="logo-thumb-container"
                        >
                          <img
                            src={process.env.REACT_APP_API_BASE + '/' + logo.libelle}
                            alt={`Logo ${logo.id}`}
                            style={{ 
                              width: '100%', 
                              height: '100%', 
                              objectFit: 'cover', 
                              cursor: 'pointer', 
                              transition: 'transform 0.2s' 
                            }}
                            onMouseOver={e => e.currentTarget.style.transform = 'scale(1.18)'}
                            onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
                          />

                          {selectedLogoId === logo.id && (
                            <span style={{
                              position: 'absolute',
                              bottom: 4,
                              left: '50%',
                              transform: 'translateX(-50%)',
                              color: 'green',
                              fontSize: 18,
                              background: '#fff',
                              borderRadius: '50%',
                              boxShadow: '0 1px 4px #0002'
                            }}>
                              <FaCheckCircle />
                            </span>
                          )}
                        </div>
                      </label>
                    </div>
                  ))
                ) : (
                  <div className="col">
                    <span className="ms-2">
                      Aucun logo accepté disponible. 
                      <a href="/home/gestion-logos" style={{ color: '#2A919D', textDecoration: 'underline' }}>
                        Gérer mes logos
                      </a>
                    </span>
                  </div>
                )}
              </div>
            </div>

        {loading && (
          <div className="alert alert-info w-100 mb-3 mt-3" style={{ textAlign: "center" }}>
            Merci de patienter, l'envoi de l'email peut prendre un peu de temps en raison de la taille des pièces jointes ou du nombre de destinataires. Merci de votre compréhension et bonne continuation.
          </div>
        )}

        <RgpdWarningModal
          show={showRgpdWarning}
          allowUnsubscribe={allowUnsubscribe}
          onClose={() => setShowRgpdWarning(false)}
          onToggle={(checked) => setAllowUnsubscribe(checked)}
        />


            <div className="d-flex flex-column w-100 justify-content-end ml-3" style={{ gap: "10px" }}>
              <div className="d-flex justify-content-end w-100 flex-wrap gap-2">
                <button
                  type="button"
                  className="btn"
                  style={{ backgroundColor: "#2A919D", color: "#fff", border: "none" }}
                  onClick={() => {
                    const newValue = !allowUnsubscribe;
                    if (!newValue) {
                      setShowRgpdWarning(true);
                    }
                    setAllowUnsubscribe(newValue);
                  }}
                >
                  <FontAwesomeIcon icon={faBellSlash} className="me-2" />
                  Pouvoir se désabonner
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-primary"
                  id="envoy"
                  ref={sendMailRef}
                >
                  {loading ? "Envoi..." : "Envoyer"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </>
    );
  };

  export default MailTab;